import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const MentionsLegales = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const sections = [
    { id: 'editeur', title: 'Éditeur du site' },
    { id: 'hebergement', title: 'Hébergement' },
    { id: 'propriete', title: 'Propriété intellectuelle' },
    { id: 'responsabilite', title: 'Responsabilité' },
    { id: 'liens', title: 'Liens hypertextes' },
    { id: 'donnees', title: 'Données personnelles' },
    { id: 'cookies', title: 'Cookies' },
    { id: 'droit', title: 'Droit applicable' },
  ];

  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <span className="legal-label">Informations légales</span>
          <h1>Mentions <span className="hdr-green">légales</span></h1>
          <p>
            Retrouvez ici les informations relatives à l'éditeur du site,
            à son hébergement et aux droits applicables. Nous restons à votre écoute
            pour toute question.
          </p>
          <div className="legal-hero__meta">
            <span className="legal-hero__meta-item">
              <i className="fas fa-calendar-alt"></i>
              Dernière mise à jour : 21 avril 2026
            </span>
            <span className="legal-hero__meta-item">
              <i className="fas fa-globe"></i>
              www.domoelec.ma
            </span>
          </div>
        </div>
      </section>

      <div className="legal-layout">
        <aside className="legal-toc">
          <p className="legal-toc__title">Sommaire</p>
          <ul>
            {sections.map((s) => (
              <li key={s.id}>
                <a href={`#${s.id}`}>{s.title}</a>
              </li>
            ))}
          </ul>
        </aside>

        <main className="legal-content">
          <section id="editeur" className="legal-section">
            <h2><span className="legal-num">1</span>Éditeur du site</h2>
            <p>
              Le présent site <strong>www.domoelec.ma</strong> est édité par la société
              <strong> DOMOELEC SARL</strong>, spécialisée dans les solutions
              professionnelles de courant faible (détection incendie, éclairage de sécurité,
              contrôle d'accès et onduleurs).
            </p>
            <ul>
              <li><strong>Raison sociale :</strong> DOMOELEC SARL</li>
              <li><strong>Forme juridique :</strong> Société à responsabilité limitée</li>
              <li><strong>Siège social :</strong> 47 Rue Des Orangers, Mag Res Eden Tower, Ain Sebaa — Casablanca, Maroc</li>
              <li><strong>Téléphone :</strong> <a href="tel:0522340659">05 22 34 06 59</a></li>
              <li><strong>Email :</strong> <a href="mailto:contact@domoelec.ma">contact@domoelec.ma</a></li>
              <li><strong>Directeur de la publication :</strong> La direction de DOMOELEC</li>
            </ul>
          </section>

          <section id="hebergement" className="legal-section">
            <h2><span className="legal-num">2</span>Hébergement</h2>
            <p>
              Le site est hébergé par un prestataire technique professionnel assurant la
              disponibilité, l'intégrité et la sécurité du service.
            </p>
            <p>
              Pour toute demande relative à l'hébergement ou à la maintenance technique,
              vous pouvez nous contacter à l'adresse <a href="mailto:contact@domoelec.ma">contact@domoelec.ma</a>.
            </p>
          </section>

          <section id="propriete" className="legal-section">
            <h2><span className="legal-num">3</span>Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu de ce site — textes, images, logos, vidéos, photographies,
              illustrations, icônes, mise en page, code source — est la propriété exclusive de
              DOMOELEC SARL ou de ses partenaires, et est protégé par les lois en vigueur
              relatives à la propriété intellectuelle.
            </p>
            <p>
              Toute reproduction, représentation, modification, publication, adaptation
              totale ou partielle des éléments du site, quel que soit le moyen ou le procédé
              utilisé, est interdite sans l'autorisation écrite préalable de DOMOELEC.
            </p>
            <div className="legal-info-card">
              <i className="fas fa-shield-alt"></i>
              <p>
                Les marques et logos des fabricants présents sur le site (partenaires, fournisseurs)
                sont la propriété de leurs détenteurs respectifs et sont reproduits à titre informatif.
              </p>
            </div>
          </section>

          <section id="responsabilite" className="legal-section">
            <h2><span className="legal-num">4</span>Responsabilité</h2>
            <p>
              DOMOELEC s'efforce de fournir des informations aussi précises et à jour que possible
              sur ce site. Toutefois, nous ne pouvons garantir l'exactitude, la précision ou
              l'exhaustivité des informations mises à disposition.
            </p>
            <h3>Disponibilité du service</h3>
            <p>
              DOMOELEC ne saurait être tenue responsable de l'indisponibilité temporaire du site
              pour cause de maintenance, de mise à jour, ou en raison de circonstances
              indépendantes de sa volonté.
            </p>
            <h3>Utilisation du site</h3>
            <p>
              L'utilisateur est responsable de l'usage qu'il fait du site et s'engage à ne pas
              l'utiliser à des fins contraires à la législation en vigueur.
            </p>
          </section>

          <section id="liens" className="legal-section">
            <h2><span className="legal-num">5</span>Liens hypertextes</h2>
            <p>
              Le site peut contenir des liens hypertextes vers des sites tiers. DOMOELEC n'exerce
              aucun contrôle sur le contenu de ces sites externes et décline toute responsabilité
              quant aux informations, pratiques ou éléments qui y figurent.
            </p>
            <p>
              La création de liens pointant vers notre site est soumise à notre autorisation
              préalable écrite.
            </p>
          </section>

          <section id="donnees" className="legal-section">
            <h2><span className="legal-num">6</span>Données personnelles</h2>
            <p>
              Les traitements de données à caractère personnel effectués via le site sont
              détaillés dans notre <Link to="/politique-confidentialite">Politique de confidentialité</Link>.
            </p>
            <p>
              Conformément à la loi 09-08 relative à la protection des personnes physiques
              à l'égard du traitement des données à caractère personnel au Maroc, vous
              disposez d'un droit d'accès, de rectification, d'opposition et de suppression
              sur vos données.
            </p>
          </section>

          <section id="cookies" className="legal-section">
            <h2><span className="legal-num">7</span>Cookies</h2>
            <p>
              Ce site utilise des cookies techniques nécessaires à son bon fonctionnement,
              ainsi que, le cas échéant, des cookies de mesure d'audience pour améliorer
              l'expérience utilisateur.
            </p>
            <p>
              Vous pouvez à tout moment configurer votre navigateur pour accepter ou refuser
              les cookies. Le refus de certains cookies peut néanmoins limiter l'accès à
              certaines fonctionnalités.
            </p>
          </section>

          <section id="droit" className="legal-section">
            <h2><span className="legal-num">8</span>Droit applicable et juridiction</h2>
            <p>
              Les présentes mentions légales sont soumises au <strong>droit marocain</strong>.
              Tout différend relatif à leur interprétation ou à leur exécution relève de la
              compétence exclusive des tribunaux de Casablanca, à défaut de résolution amiable.
            </p>
          </section>

          <div className="legal-cta">
            <div className="legal-cta__text">
              <h3>Une question juridique ?</h3>
              <p>Notre équipe est disponible pour répondre à toutes vos demandes.</p>
            </div>
            <a href="mailto:contact@domoelec.ma" className="legal-cta__btn">
              <i className="fas fa-envelope"></i>
              Nous contacter
            </a>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MentionsLegales;
